var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.renderRouterView)?_c('v-navigation-drawer',{attrs:{"app":"","clipped":"","right":"","disable-resize-watcher":""},model:{value:(_vm.sideSheet),callback:function ($$v) {_vm.sideSheet=$$v},expression:"sideSheet"}},[_c('router-view',{attrs:{"name":"sideSheet"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }